import React from 'react'

// Components
import { Skeleton } from '@sketch/components'

// Local Components
import { WorkspaceProfilePublications } from '../WorkspaceProfilePublications'

// Styles
import {
  Container,
  ProfileAvatar,
  ProfileHeader,
  ProfileInfoContainer,
  PublishedDocumentsContainer,
} from './WorkspaceProfileLayout.styles'

// Hooks
import type {
  WorkspaceProfileResultLoading,
  WorkspaceProfileResultSuccess,
} from 'modules/workspaceProfile/hooks/useGetWorkspaceProfile'

interface WorkspaceProfileLayoutProps {
  workspaceId: string
  isProfileEditRoute: boolean
  profileResult: WorkspaceProfileResultSuccess | WorkspaceProfileResultLoading
  profileInfo: React.ReactNode
}

export const WorkspaceProfileLayout = (props: WorkspaceProfileLayoutProps) => {
  const { profileResult, isProfileEditRoute, profileInfo } = props
  const { profile, loading } = profileResult

  const profileContent = loading ? (
    <>
      <Skeleton width="320px" height="48px" style={{ marginBottom: 12 }} />
      <Skeleton width="470px" height="30px" style={{ marginBottom: 8 }} />
      <Skeleton width="350px" height="30px" style={{ marginBottom: 8 }} />
      <Skeleton width="350px" height="30px" />
    </>
  ) : (
    profileInfo
  )

  return (
    <Container isProfileEditRoute={isProfileEditRoute}>
      <ProfileHeader>
        <ProfileAvatar
          workspaceName={profile?.workspace.name!}
          avatar={profile?.workspace.avatar?.large}
        />
        <ProfileInfoContainer>{profileContent}</ProfileInfoContainer>
      </ProfileHeader>

      <PublishedDocumentsContainer>
        <WorkspaceProfilePublications {...props} />
      </PublishedDocumentsContainer>
    </Container>
  )
}
